import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ size = 'medium' }) => {
  const sizeClasses = {
    small: 'h-4 w-4 border-2',
    medium: 'h-8 w-8 border-4',
    large: 'h-12 w-12 border-4'
  };

  return (
    <div className="flex justify-center items-center">
      <div 
        className={`animate-spin rounded-full border-solid border-t-transparent ${sizeClasses[size]}`}
        style={{ borderColor: 'currentColor' }}
      />
    </div>
  );
};

export default LoadingSpinner;